module.exports = __webpack_public_path__ + "img/b4.8a56013.png";